import React from 'react';
import styled from 'styled-components';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Section from '@components/elements/section';
import { theme } from '@styles';
const { colors } = theme;

const StyledGrid = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));

  .child-photo {
    width: 100%;
    height: 100%;
  }
`;

const HoverblueBG = styled.div`
  background-color: ${colors.hoverBlue};
  position: absolute;
  width: 100%;
  height: 50%;
  top: 50%;
  z-index: -1;
`;

const PhotoList = ({ data }) => {
  return (
    <div style={{ position: 'relative' }}>
      <Section padding={'ph80_small'}>
        <StyledGrid>
          {data?.map((photo, index) => {
            return (
              <div key={index}>
                {photo && (
                  <GatsbyImage
                    image={getImage(photo)}
                    className="child-photo"
                    alt={`member-photo-${index} || "photo grid item"`}
                  />
                )}
              </div>
            );
          })}
        </StyledGrid>
      </Section>
      <HoverblueBG />
    </div>
  );
};

export default PhotoList;
